import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlSystemMarketListRequest } from "../../models/service-models/market/SystemMarketListRequest";
import { MarketService } from "../../services/MarketService";
import { mdlServiceResponse } from "../../models/service-models/common/ServiceResponse";
import { mdlSystemMarketListResponse } from "../../models/service-models/market/SystemMarketListResponse";

export type SsytemMarketSelectProps = {
    onChange?: Function;
    onLoad?: Function;
    value?: any;
    mode?: 'multiple' | 'tags' | undefined;
}


export const SystemMarketSelect = memo(function SystemMarketSelect(props: SsytemMarketSelectProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);
    
    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getSystemMarkets"],
        () => {
            var request: mdlSystemMarketListRequest = { pageSize: 0 };
            return MarketService.SystemMarketList(request);
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    useEffect(() => {
        if (data?.body?.data && props.onLoad) {
            props.onLoad(data?.body?.data);
        }
    }, [data]);

    return (
        <>
            <Select            
                mode={props.mode}
                loading={isLoading}
                size="large"
                value={props.value}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseSystemMarket")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.marketId
                }))}
            />
        </>
    )
})